const onLock = () => {
    try {
        window.ElectronSettingApi.lock.on();
    } catch (e) {
        Often.toast('error', i18next.t(main.alert.errorTryAgain));
    }
}
const unLock = () => {
    try {
        window.ElectronSettingApi.lock.show();
    } catch (e) {
        Often.toast('error', i18next.t(main.alert.errorTryAgain));
    }
}
const getLockSetting = (props) => {
    try {
        return window.ElectronSettingApi.lock.set(props)
    } catch (e) {
        Often.toast('error', i18next.t(main.alert.errorTryAgain));
    }
}

export {
    onLock,
    unLock,
    getLockSetting
};